module.exports = __webpack_public_path__ + "static/img/32.6443342.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/32.png
// module id = gdvE
// module chunks = 1